// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UploadOutlinedSvg from "@fishx/icons-svg/es/asn/UploadOutlined";
import FishxIcon from '../components/FishxIcon';

var UploadOutlined = function UploadOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: UploadOutlinedSvg
  }));
};

UploadOutlined.displayName = 'UploadOutlined';
export default React.forwardRef(UploadOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/UploadOutlined.js
// module id = 4327
// module chunks = 0